<template>
  <div v-if="locationSet || loading">{{ loadingText }}</div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ClosestIsLoading",
  computed: {
    ...mapState('nearbyRoutes', ['locationSet', 'loading']),

    loadingText() {
      if (!this.locationSet) {
        return 'Determinig your location';
      } else if (this.loading) {
        return 'Loading';
      }

      return '';
    },

  },
}
</script>

<style scoped>

</style>
